// Material UI
import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

// Colours
import { terracotta, grey } from "Constants/ColourConstants";

const drawerWidth = 240;

export const styles = {
  listItemButton: (open) => ({
    minHeight: 48,
    px: 2.5,
    justifyContent: open ? "initial" : "center",
  }),
  listItemIcon: (open, isActive) => ({
    minWidth: 0,
    justifyContent: "center",
    mr: open ? "24px" : "auto",
    color: isActive ? terracotta : grey,
  }),
};

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  "& .MuiDrawer-paper": {
    top: 64,
    height: "calc(100% - 64px)",
  },
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": {
          ...openedMixin(theme),
          top: 64,
          height: "calc(100% - 64px)",
        },
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": {
          ...closedMixin(theme),
          top: 64,
          height: "calc(100% - 64px)",
        },
      },
    },
  ],
}));
